var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{staticClass:"form-control",attrs:{"options":_vm.datos,"track-by":"id","label":"nombre","searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Seleccione..."},model:{value:(_vm.modelo.idarea),callback:function ($$v) {_vm.$set(_vm.modelo, "idarea", $$v)},expression:"modelo.idarea"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }